module.exports = __webpack_public_path__ + "img/plate_photo_4.993b39c7.jpg";